import { inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserInformationService } from '../user/user-information.service';
import { LanguageService } from '../language/language.service';
import { PinAuthService } from './pin-auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly languageService = inject(LanguageService);
  private readonly oauthService = inject(OAuthService);
  private readonly userInformationService = inject(UserInformationService);
  private readonly pinAuthService = inject(PinAuthService);

  public hasValidAccessToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  public async logout(): Promise<void> {
    this.userInformationService.removeSavedAccount();

    // Сбрасываем PIN/биометрию до OAuth-разлогина: logOut() инициирует редирект,
    // и иначе остаётся микро-окно, когда ключи всё ещё в SecureStorage.
    await this.pinAuthService.resetAll();

    this.oauthService.logOut({
      lang: this.languageService.getCurentLanguage(),
    });
  }
}
